import { Page } from "../../enums/page";
import { config } from "../config";
import {addressTranslation} from "./address-translation";

const addressLogic =  {
    getAddressTranslator : function (language, country) {
        return addressTranslation.address[language + '-' + country] || addressTranslation.address[country] || {};
    },

    getCountryTranslation : function(_countryCode, _locale) {
        if(addressTranslation.country[_countryCode]) {
            return addressTranslation.country[_countryCode][_locale] || addressTranslation.country[_countryCode][config('language')];
        }
        return '';
    },
    getMyAccountAddressSequenceProps : function(_country) {
        if (_country && addressTranslation.addressSequenceProps_myAccount[_country.toUpperCase()])
            return addressTranslation.addressSequenceProps_myAccount[_country.toUpperCase()];
        return addressTranslation.addressSequenceProps_myAccount['default'];
    },
    getAddressSequenceProps : function(currentSiteName, pageType) {
        // eslint-disable-next-line no-undef
        if(pageType === Page.CHECKOUTSHIPPING) {
            return this.getCheckoutAddressSequenceProps(currentSiteName);
        }
        return this.getMyAccountAddressSequenceProps(currentSiteName);
    },
    getCheckoutAddressSequenceProps : function(_country) {
        if (_country && addressTranslation.addressSequenceProps_checkout[_country.toUpperCase()])
            return addressTranslation.addressSequenceProps_checkout[_country.toUpperCase()];
        return addressTranslation.addressSequenceProps_checkout['default'];
    },
    getAllSitesData : function () {
        // eslint-disable-next-line no-undef
        const allSites = addressTranslation.country;
        const allSitesData = {};
        for (let i in allSites) {
            allSitesData[i.toUpperCase()] = {
                countryCode: i.toUpperCase(),
                // eslint-disable-next-line no-undef
                country: this.getCountryTranslation(i, config('locale'))
            };
        }
        return allSitesData;
    },
    getAddressFieldValue : function(_field: any, addressObj: any, allSitesData: any) {
        if (addressObj[_field]) {
            if (_field === 'country')
                return allSitesData[addressObj[_field]]?.country;
            else
                return addressObj[_field];
        } else if (_field === '<br>' || _field === ' ' || _field === ',') {
            return _field + '';
        }
        return '';
    },
    getFormatedDisplayAddress : function(address, pageType) {
        // eslint-disable-next-line no-undef
        if(!address) return;

        let phoneNumber: any = '';
        
        let displayAddress = this.getDisplayAddress(address, this.getAddressSequenceProps(config('regionCode').toLowerCase(), pageType), this.getAllSitesData());
        if((pageType !== Page.CHECKOUTSHIPPING && (address.country === 'US' || address.country === 'CA') || (pageType === Page.ORDERDETAILS))){
            let displayAddressArray = displayAddress.split('<br>');
            let phoneNoExtString = displayAddressArray[displayAddressArray.length-1];
            phoneNumber = phoneNoExtString;
            displayAddressArray[displayAddressArray.length-1] = '';
            displayAddress =  displayAddressArray.join('<br>');
        }
        return {displayAddress, phoneNumber};
    },
    getDisplayAddress : function(addressObj: any, addressPropsSequence: any, allSitesData: any) {
        let returnSequence = '';
        let propertyName = '';
        let propertyArr = [];
        for (let i = 0; i < addressPropsSequence.length; i++) {
            propertyName = addressPropsSequence[i];
            if (propertyName.indexOf('?') > -1) {
                propertyArr = propertyName.split('?') as any;
                let addressFieldValue = this.getAddressFieldValue(propertyArr[0], addressObj, allSitesData);
                if (addressFieldValue !== '') {
                    returnSequence += addressFieldValue;
                    returnSequence += this.getAddressFieldValue(propertyArr[1], addressObj, allSitesData);
                }
            } else if (propertyName.indexOf(',') > -1) {
                propertyArr = propertyName.split(',') as any;
                let tempArr : any = [];
                for (let j = 0; j < propertyArr.length; j++) {
                    const res = this.getAddressFieldValue(propertyArr[j], addressObj, allSitesData);
                    tempArr.push(res);
                }
                returnSequence += tempArr.join(', ');
            }
            else if(allSitesData !== Page.ORDERDETAILS && propertyName==='phone' && (addressObj.country === 'US' || addressObj.country === 'CA')){
                let rawPhoneNumber = this.getAddressFieldValue(propertyName, addressObj, allSitesData);
                rawPhoneNumber = rawPhoneNumber.replace(/[^\d]/g, '');
                if(rawPhoneNumber) {
                    returnSequence += '('+rawPhoneNumber.substring(0, 3)+') ' + rawPhoneNumber.substring(3, 6) + '-' + rawPhoneNumber.substring(6, 10);
                }
            }
            else if (allSitesData === Page.ORDERDETAILS && propertyName === 'phone') {
              if ((addressObj.country === 'US' || addressObj.country === 'CA')) {
                let rawPhoneNumber = this.getAddressFieldValue(propertyName, addressObj, allSitesData);
                rawPhoneNumber = rawPhoneNumber.replace(/[^\d]/g, '');
                if (rawPhoneNumber) {
                  returnSequence += '(' + rawPhoneNumber.substring(0, 3) + ') ' + rawPhoneNumber.substring(3, 6) + '-' + rawPhoneNumber.substring(6, 10);
                }
              }
              else {
                let rawPhoneNumber = this.getAddressFieldValue(propertyName, addressObj, allSitesData);
                rawPhoneNumber = rawPhoneNumber.replace(/[^\d]/g, '');
                if (rawPhoneNumber) {
                  returnSequence += rawPhoneNumber;
                }
              }
            }
            else if(propertyName==='extension'){

                let temp = this.getAddressFieldValue(propertyName, addressObj, allSitesData);
                if(temp){
                    returnSequence += ' Ext: '+ temp;
                }
            } else {
                returnSequence += this.getAddressFieldValue(propertyName, addressObj, allSitesData);
            }
        }
        return returnSequence;
    }
};

export default addressLogic;